import React from "react";
import {
	SharedApplication,
	SharedArticle,
	SharedCarousel,
	SharedCourse,
	SharedGroup,
	SharedLive,
	SharedOrganization,
	SharedPost,
	SharedQuiz,
	SharedQuizResult,
} from "@domain/post/post";
import { OrganizationThumbnail } from "@ui/pages/searchPage/organizationThumbnail";
import { ApplicationStoryThumbnail } from "@ui/components/application/applicationStoryThumbnail";
import { ArticleThumbnail } from "@ui/components/article/articleThumbnail";
import { CourseThumbnail } from "@ui/components/course/courseThumbnail";
import { DiscussionThumbnail } from "@ui/components/group/discussionThumbnail";
import { ShareroomThumbnail } from "@ui/components/group/shareroomThumbnail";
import { LivecourseThumbnail } from "@ui/components/livecourse/livecourseThumbnail";
import { QuizResultThumbnail } from "@ui/components/quiz/quizResultThumbnail";
import { QuizThumbnail } from "@ui/components/quiz/quizThumbnail";
import { PostContentDeleted } from "@ui/components/post/postCourseDeleted";
import { ReadonlyPost } from "@ui/components/post/readonlyPost";

interface PostReferenceProps extends React.HTMLAttributes<HTMLDivElement> {
	post:
		| SharedPost
		| SharedQuiz
		| SharedQuizResult
		| SharedCourse
		| SharedOrganization
		| SharedGroup
		| SharedArticle
		| SharedCarousel
		| SharedLive
		| SharedApplication;
}

export const PostReference: React.FC<PostReferenceProps> = ({ post, ...htmlProps }) => {
	return (
		<div {...htmlProps}>
			{post.type === "SHARE_COURSE" &&
				(post.reference ? <CourseThumbnail course={post.reference} /> : <PostContentDeleted type="course" />)}
			{post.type === "SHARE_LIVE_COURSE" &&
				(post.reference ? (
					<LivecourseThumbnail livecourse={post.reference} post={post} />
				) : (
					<PostContentDeleted type="live" />
				))}
			{post.type === "SHARE_APPLICATION" &&
				(post.reference && post.reference.person ? (
					// <ApplicationStoryCard  profile={post.reference.person} isFeed />
					<ApplicationStoryThumbnail application={post.reference} person={post.reference.person} isFeed />
				) : (
					<PostContentDeleted type="application" />
				))}
			{post.type === "SHARE_ARTICLE" &&
				(post.reference ? (
					<ArticleThumbnail forFeed article={post.reference} />
				) : (
					<PostContentDeleted type="article" />
				))}

			{post.type === "SHARE_QUIZ" &&
				(post.reference?.status === "PUBLISHED" ? (
					<QuizThumbnail quiz={post.reference} />
				) : (
					<PostContentDeleted type="quiz" />
				))}
			{post.type === "SHARE_QUIZ_RESULTS" &&
				(post.reference?.status === "PUBLISHED" ? (
					<QuizResultThumbnail quiz={post.reference} />
				) : (
					<PostContentDeleted type="quiz" />
				))}
			{post.type === "SHARE_ORGANIZATION" &&
				(post.reference ? (
					<OrganizationThumbnail small organization={post.reference} />
				) : (
					<PostContentDeleted type="organization" />
				))}
			{post.type === "SHARE_POST" &&
				(post.reference ? <ReadonlyPost post={post.reference} /> : <PostContentDeleted type="post" />)}
			{post.type === "SHARE_GROUP" &&
				(post.reference ? (
					post.reference.type === "SHAREROOM" ? (
						<ShareroomThumbnail border shareroom={post.reference} />
					) : (
						<DiscussionThumbnail border discussion={post.reference} />
					)
				) : (
					<PostContentDeleted type="group" />
				))}
		</div>
	);
};
